import React from "react";
import Header from "./Header/Header";
import Content from "./Content/Content";
import Footer from "./Footer/Footer";
import ScrollProgress from "./UI/ScrollProgress/ScrollProgress";

const Layout = () => {
  return (
    <>
      <ScrollProgress />
      <Header />
      <Content />
      <Footer />
    </>
  );
};

export default Layout;
